import * as React from 'react'

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { SubscriptionTier } from '../../../../../../models';
import Centered from '../../../../../../components/Centered';
import { titleCase, to2DecimalPlaces } from '../../../../../../helpers';


const SubscriptionTierView: React.FC<
    {
        subscriptiontier: SubscriptionTier;
    }
> = ({
    subscriptiontier
}) => {


        return (
            <Centered >
                <Paper style={{
                    padding: '1em',
                    borderRadius: '14px',
                    border: 'none',
                    width:'80%',

                    maxWidth: '450px',

                }} elevation={2} >
                    <Typography textAlign={'center'} fontWeight="bold"
                        component="h6" variant="h6">
                        {titleCase(subscriptiontier.name)}
                    </Typography>
                    <Typography variant='subtitle1' fontSize={'14px'} color={'#6B779A'} textAlign={'center'} sx={{
                        mt: 1,
                    
                    }}>

                        {to2DecimalPlaces(subscriptiontier.price, true)}
                    </Typography>
                    <Typography variant='subtitle1' textAlign={'center'} sx={{
                        mt: 1,


                    }}
                        fontWeight="bold"
                    >
                      Maximum of  {subscriptiontier.maxMembers} user(s)
                    </Typography>
                </Paper >
            </Centered>
        )
    }

export default SubscriptionTierView